import { Audience } from './audience'

export type ClientStatus = {
  label: string
  value: string
}

export enum LoanStatus {
  ELIGIBLE = 'eligible',
  NOT_ELIGIBLE = 'not_eligible',
  IN_REVIEW = 'in_review',
  UNKNOWN = 'unknown',
  SUBMITTED = 'submitted',
  PRE_APPROVED = 'pre_approved',
  UNDER_CONTRACT = 'under_contract',
  FINAL_APPROVED = 'final_approved',
  CLEARED_TO_CLOSE = 'cleared_to_close',
  FUNDED = 'funded',
  COMPLETED = 'completed',
}

export const LENDER_PRE_LOAN_APPLICATION_STATUSES: ClientStatus[] = [
  {
    label: 'Bridge Loan Estimate',
    value: LoanStatus.ELIGIBLE,
  },
  {
    label: 'Not Eligible',
    value: LoanStatus.NOT_ELIGIBLE,
  },
  {
    label: 'In Review',
    value: LoanStatus.IN_REVIEW,
  },
]

export const AGENT_PRE_LOAN_APPLICATION_STATUSES: ClientStatus[] = [
  {
    label: 'Eligible',
    value: LoanStatus.ELIGIBLE,
  },
  {
    label: 'Not Eligible',
    value: LoanStatus.NOT_ELIGIBLE,
  },
  {
    label: 'In Review',
    value: LoanStatus.IN_REVIEW,
  },
]

export const LENDER_MAIN_STATUSES: ClientStatus[] = [
  {
    label: 'App Submitted',
    value: LoanStatus.SUBMITTED,
  },
  {
    label: 'Pre-Approved',
    value: LoanStatus.PRE_APPROVED,
  },
  {
    label: 'Under Contract',
    value: LoanStatus.UNDER_CONTRACT,
  },
  {
    label: 'Final Approved',
    value: LoanStatus.FINAL_APPROVED,
  },
  {
    label: 'Cleared to Close',
    value: LoanStatus.CLEARED_TO_CLOSE,
  },
  {
    label: 'Funded',
    value: LoanStatus.FUNDED,
  },
  {
    label: 'Completed',
    value: LoanStatus.COMPLETED,
  },
]

export const AGENT_MAIN_STATUSES: ClientStatus[] = [
  {
    label: 'App Submitted',
    value: LoanStatus.SUBMITTED,
  },
  {
    label: 'Pre-Approved',
    value: LoanStatus.PRE_APPROVED,
  },
  {
    label: 'Under Contract',
    value: LoanStatus.UNDER_CONTRACT,
  },
  {
    label: 'Closing',
    value: LoanStatus.CLEARED_TO_CLOSE,
  },
  {
    label: 'Selling',
    value: LoanStatus.FUNDED,
  },
  {
    label: 'Completed',
    value: LoanStatus.COMPLETED,
  },
]

export const getLoanStatusLabel = (audience: Audience, status: string) => {
  const statusOptions =
    audience === Audience.LENDER
      ? [...LENDER_PRE_LOAN_APPLICATION_STATUSES, ...LENDER_MAIN_STATUSES]
      : [...AGENT_PRE_LOAN_APPLICATION_STATUSES, ...AGENT_MAIN_STATUSES]

  const matchingStatus = statusOptions.find((filter) => filter.value === status)

  return matchingStatus ? matchingStatus.label : 'Unknown Status'
}
